import * as React from 'react';
import * as classNames from 'classnames';
import {SFC} from 'react';
import {Markdown} from '../../markdown/markdown';
import './styles.sass';

interface IAccordionItemDetailsProps {
  expanded: boolean;
  children?: any;
  text?: string;
}

export const AccordionItemDetails: SFC<IAccordionItemDetailsProps> = ({
  expanded,
  children,
  text,
}) => (
  <div className={classNames('accordion-item-details', {'accordion-item-details_expanded': expanded})}>
    <Markdown>{text}</Markdown>
    {children}
  </div>
);
